import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login/login.component';
import { OtpComponent } from './otp/otp.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { UnlockAccountComponent } from './unlock-account/unlock-account.component';
import { ValidateUserComponent } from './validate-user/validate-user.component';
import { LoginBaseComponent } from './login-base/login-base.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { RegisterUserComponent } from './register-user/register-user.component';
import { PasswordExpiredComponent } from './password-expired/password-expired.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MinuteSecondsPipe } from 'src/app/pipe/minute-seconds.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { RegisterBaseComponent } from './register-base/register-base.component';
import { MenuMappingComponent } from './menu-mapping/menu-mapping.component';
import { PasswordPolicyComponent } from './password-policy/password-policy.component';
import { ContactComponent } from './contact/contact.component';
import { RegisterEmailComponent } from './register-email/register-email.component';
import { RegisterMasterComponent } from './register-master/register-master.component';
import { DataTablesModule } from 'angular-datatables';


@NgModule({
  declarations: [
    LoginComponent,
    OtpComponent,
    ForgotPasswordComponent,
    UnlockAccountComponent,
    ValidateUserComponent,
    LoginBaseComponent,
    ChangePasswordComponent,
    RegisterUserComponent,
    PasswordExpiredComponent,
    RegisterBaseComponent,
    MenuMappingComponent,
    PasswordPolicyComponent,
    ContactComponent,
    RegisterEmailComponent,
    RegisterMasterComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BsDatepickerModule,
    DataTablesModule
  ]
})
export class LoginModule { }
